import { isHyperError } from './isHyperError';
var parseHyperError = function (err, methodType) {
    if (methodType === void 0) { methodType = ''; }
    if (!isHyperError(err))
        throw err;
    var parsedResponse = {};
    try {
        parsedResponse = JSON.parse(err.response);
    }
    catch (_a) {
        // swallow parsing errors (consumer will receive `{}`)
    }
    return {
        hyperCode: err.code,
        hyperMessage: err.message,
        methodType: methodType,
        response: parsedResponse,
        responseText: err.response,
        status: err.status,
    };
};
export { parseHyperError };
//# sourceMappingURL=parseHyperError.js.map